<template>
    <div class="content">
      <h1>Personal Projects</h1>
      <p>Placeholder.</p>
    </div>
</template>

